<template>
  <div id="cesium-container" ref="cesiumContainer">
    <cesium-recorder ref="cesiumRecorder" />
  </div>
</template>

<script>
import { CesiumInitialization } from '../../components/ThreeD/CesiumInitialization'
import { PointOfInterest } from '../../components/ThreeD/PointOfInterest'
import CesiumRecorder from '../../components/ThreeD/CesiumRecorder.vue'

export default {
  name: 'POI-cesium-viewer',
  mixins: [CesiumInitialization, PointOfInterest],
  props: ['coordinates'],
  components: {
    'cesium-recorder': CesiumRecorder
  },
  watch: {
    coordinates: {
      handler(coord) {
        if (!isNaN(coord.longitude) && !isNaN(coord.latitude)) {
          this.onCoordinatesChangedInForm(coord)
        }
      },
      deep: true
    }
  },

  mounted() {
    this.initializeViewer()
    this.insertElementInToolbar(this.$refs.cesiumRecorder.$el)
    this.deactivateControls()
    this.initializeCursorEntity()
    this.onCoordinatesChangedInForm(this.coordinates)
  }
}
</script>

<style scoped>
#cesium-container {
  position: relative;
  height: 500px;
  width: 100%;
  z-index: 999;
}
</style>
